/*********************************************************
 * Third Controls
*********************************************************/
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from "react-infinite-scroll-component";
/*********************************************************
 * Components
*********************************************************/
import { SidePanelFooter } from 'Components/SidePanel';
import { Button } from 'Components';
import InputSearch from 'Components/InputSearch';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { NotificationManager } from 'Components/Notifications';
import { LinearProgress } from 'Components';
import { TypeObjectMap } from '../../../../../../../components/Map/providers/enums'
//import { Tooltip } from 'Components';

import {
  Icons,
  Switch,
  Tooltip,
} from "@gpstrackit/gtc-react-controls";

/*********************************************************
 * Actions
*********************************************************/
import {
  getRoutesLayerMap,
  getRouteLayerMap,
  addPointers,
  drawGetDirections,
  clearLayers
} from 'Redux/actions';
// Helpers
import { truncateString } from '../../../../../../../core/hooks'

/*********************************************************
 * Styles
*********************************************************/
import './styles.scss';

const Route = (props) => {
  const dispatch = useDispatch()
  const { handleView, messages, mapRef } = props


  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState('');
  const [currentRoute, setCurrentRoute] = useState({});
  const loadingRoute = useSelector(state => state.realtimeMapLayerMapModuleRedux.loadingRoute);
  const routes = useSelector(state => state.realtimeMapLayerMapModuleRedux.routes);
  const loadingRoutes = useSelector(state => state.realtimeMapLayerMapModuleRedux.loadingRoutes);
  const allRoutes = useSelector(state => state.realtimeMapLayerMapModuleRedux.allRoutes);
  const loadingAllRoutes = useSelector(state => state.realtimeMapLayerMapModuleRedux.loadingAllRoutes);
  const [routeIds, setRouteIds] = useState([]);
  const [showItems, setShowItems] = useState([])

  useEffect(() => {
    return () => {
      //dispatch(clearLayers());
      //dispatch(addPointers([]));
      //dispatch(drawGetDirections(false));
      mapRef?.current?.showUnitsByPreferences();
      setRouteIds([]);
      setCurrentRoute({});
    }
  }, []);

  const handleRoute = (selected) => {
    setCurrentRoute(selected);
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(getRoutesLayerMap({ search: search, limit, offset: 0 }))
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [search, 1000]);

  const getMoreRoutes = () => {
    let currentLimit = limit + 100
    setLimit(currentLimit)
    dispatch(getRoutesLayerMap({ search, limit: currentLimit, offset: 0 }))
  }

  const height = `calc(90vh - 30px)`;

  const getRoute = (paramRouteId = 0) => {
    const routeId = paramRouteId ? paramRouteId?.id : currentRoute?.id

    if (routeId) {
      dispatch(getRouteLayerMap(routeId));
    } else {
      NotificationManager.warning(
        messages['realtimemaps_layer_map_select_route'],
        messages['realtimemaps_layer_map_route'],
        3000,
        null,
        null,
        'warning',
        null);
    }
  }

  useEffect(() => {
    dispatch(getRoutesLayerMap({ search, limit, offset: 0 }))
  }, []);

  useEffect(() => {
    if (routes && routes.length > 0) {
      routes.map((route) => {
        dispatch(addPointers(route.points));
        dispatch(drawGetDirections(true));
      })
      //in start module load the current routes.
      if(routeIds.length == 0){
        setRouteIds(routes.map(item => { return (item.id)}))
        setShowItems(routes)
      }                
    }
  }, [routes])

  const showItem = (status, item) => {
    if (status) {
        setShowItems([...showItems, item])
        let current = routeIds
        current.push(item.id);
        setRouteIds(current)
    } else {
        const filterItems = showItems?.filter(previous => previous?.id !== item?.id)
        setShowItems(filterItems)
        const filterRoutesIds = routeIds?.filter(previous => previous !== item?.id)
        setRouteIds(filterRoutesIds)

    }
  }

  return (
    <div>
      <InputSearch
        onSearch={(txt) => setSearch(txt)}
        searchText={search}
      />
      {
        loadingAllRoutes
        &&
        <LinearProgress color="primary" />
      }
      {allRoutes.items && (
        <div id="scrollableDiv" style={{ height: height, overflow: "auto" }}>
          {allRoutes.items.length > 0 ? (
            <InfiniteScroll
              dataLength={allRoutes.items.length}
              next={getMoreRoutes}
              hasMore={allRoutes?.items?.length < allRoutes?.total}
              loader={<h4>{messages['loading']}</h4>}
              scrollableTarget="scrollableDiv"
            >
              {allRoutes.items.map((route, index) => {
                let validate = routeIds.length > 0 && routeIds.some((r) => r === route.id)
                
                return (
                  <div className={`route-card`} 
                        key={index} 
                        onClick={() => handleRoute(route)}
                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                      <CheckCircleOutlineIcon />
                      <div style={{ width: '130px'}}>
                        {
                          route?.title?.length > 30
                          ?
                            <Tooltip title={route.title} placement={'bottom'} >
                              <span style={{ marginLeft: 15 }} className='route-ellipsis' >{route.title}</span>
                            </Tooltip>
                          :
                            <span style={{ marginLeft: 15 }} className='route-ellipsis' >{route.title}</span>
                        }
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {
                        showItems?.find(
                          (selected) => selected?.id === route?.id
                        )
                        &&
                        <Tooltip
                          title={messages["realtimemaps_layer_map_layer_follow"]}
                        >
                          <Icons
                            size="medium"
                            style={{ paddingLeft: 1, marginRight: "10px", cursor: "pointer" }}
                            name="visibility"
                            onClick={() =>{
                              const routeWithPoints = routes.find((routeValue) => routeValue.id == route?.id)
                              if(routeWithPoints && routeWithPoints?.points){
                                const pointsOnRoute = routeWithPoints.points.map((routePoint) => ({ lat: routePoint.latitude, lng: routePoint.longitude}) )
                                mapRef?.current?.centerByFitBounds(pointsOnRoute);
                              }
                            }}
                          />
                        </Tooltip>
                      }
                      <div style={{ width: "100px" }}>
                          <Switch
                            //isDisabled={disabledSwitch(item)}
                            optionLabels={[messages["show"], messages["hide"]]}
                            onChange={(e) => {
                              if(e){
                                handleRoute(route);
                                getRoute(route);
                              }else{
                                //remove item from map
                                setCurrentRoute({});
                                mapRef?.current?.removeMapObject(`layerRoute_${route.id}`, TypeObjectMap.Routes );
                                dispatch(addPointers([]));
                              }
                              showItem(e, route);
                            }}
                            checked={showItems?.find(
                              (selected) => selected?.id === route?.id
                            )}
                          />
                      </div>
                    </div>
                  </div>
                )
              })}
            </InfiniteScroll>
          ) : (
            <div className="route-card-no-routes">
              <span>{messages['realtimemaps_layer_map_no_routes_available']}</span>
            </div>
          )}
        </div>
      )}

      <SidePanelFooter>
        <Button
          className='btn-cancel'
          onClick={() => {
            handleView(0);
            //dispatch(clearLayers());
            //dispatch(addPointers([]));
            //dispatch(drawGetDirections(false));
            setRouteIds([]);
            setCurrentRoute({});
          }}
          disabled={loadingRoutes || loadingRoute}
        >
          {messages['realtimemaps_layer_map_back']}
        </Button>
        {/* <Button
          className='btn-blue'
          onClick={() => getRoute()}
          disabled={loadingRoutes || loadingRoute}
        >
          {messages['realtimemaps_layer_map_add']}
        </Button> */}
      </SidePanelFooter>
    </div>
  )
}

export default Route;